import React from "react"

import Image from "@atoms/Image/Image"

import styles from "./ImageFullWidth.module.scss"

const ImageFullWidth = ({ image, imagePreload }) => {
  if (!image) return null
  return (
    <section
      className={`${styles.element} ${
        !image ? styles.noImage : styles.hasImage
      } section-break-out section-capped-width make-full-width-on-mobile large-area-element`}
    >
      {image && (
        <Image
          widths={[480, 720, 1080, 1440, 1600]}
          fill={true}
          blurred={240}
          image={image}
          preload={imagePreload}
        />
      )}
    </section>
  )
}

export default ImageFullWidth
